export const capitalizeFirstLetter = (val) => {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1).toLowerCase();
}

export const capitalizeFirstLetters = (val) => {
  return val.split(' ').map(capitalizeFirstLetter).join(' ')
}
